import type { Brand } from '../../lib/brand';

/** Identifiers minted only here, so a keypad id can never be a key id. */
export type KeypadId = Brand<string, 'KeypadId'>;
export type KeypadKeyId = Brand<string, 'KeypadKeyId'>;

const ID_PREFIX = {
  KEYPAD: 'keypad',
  KEY: 'key',
} as const;

const ID_SUFFIX = {
  RADIX: 36,
  RANDOM_START: 2,
  RANDOM_END: 10,
} as const;

/**
 * `crypto.randomUUID` needs a secure context, and these tablets are often served
 * over plain http on the local network.
 */
const canUseRandomUuid = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function';

const randomSuffix = (): string =>
  canUseRandomUuid
    ? crypto.randomUUID()
    : `${Date.now().toString(ID_SUFFIX.RADIX)}${Math.random()
        .toString(ID_SUFFIX.RADIX)
        .slice(ID_SUFFIX.RANDOM_START, ID_SUFFIX.RANDOM_END)}`;

export const newKeypadId = (): KeypadId => `${ID_PREFIX.KEYPAD}_${randomSuffix()}` as KeypadId;

export const newKeypadKeyId = (): KeypadKeyId =>
  `${ID_PREFIX.KEY}_${randomSuffix()}` as KeypadKeyId;

/** Adopts an id that came from stored JSON. Only the decoder needs this. */
export const asKeypadId = (value: string): KeypadId => value as KeypadId;
export const asKeypadKeyId = (value: string): KeypadKeyId => value as KeypadKeyId;
